import { TranslationProps } from '@/config/locale/type';

export type TOption = { label: string; value: string };

export const searchOrderByCategoryOptionList = [
  { label: '내림차순', value: 'desc' },
  { label: '오름차순', value: 'asc' },
];

export const rowsPerPageOptionList = [
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '50', value: '50' },
];

export type SortBased = { value: string; translationData: TranslationProps };
